{
  "title": "Kampagnen",
  "subtitle": "Ein Banner unter der Signatur, zwischen zwei Daten. Legen Sie die Daten fest und es erscheint und verschwindet von selbst — niemand muss sich erinnern, es zu entfernen.",
  "newCampaign": "Neue Kampagne",
  "emptyTitle": "Keine Kampagnen",
  "emptyBody": "Eine Kampagne füllt den Banner-Platz in einer Signaturvorlage. Fügen Sie den Platz zuerst im Designer hinzu, sonst hat das Banner keinen Ort.",
  "liveNow": "Jetzt live",
  "noBanner": "Kein Banner",
  "statusDraft": "Entwurf",
  "statusScheduled": "Geplant",
  "statusActive": "Aktiv",
  "statusRunning": "Läuft",
  "statusPaused": "Pausiert",
  "statusEnded": "Beendet",
  "edit": "Bearbeiten",
  "pause": "Pausieren",
  "resume": "Fortsetzen",
  "schedule": "Planen",
  "startNow": "Jetzt starten",
  "end": "Beenden",
  "delete": "Löschen",
  "deleteConfirm": "Diese Kampagne löschen?",
  "name": "Name",
  "namePlaceholder": "Frühlings-Roadshow",
  "starts": "Beginn",
  "ends": "Ende",
  "banner": "Banner",
  "chooseBanner": "Banner wählen",
  "chooseImage": "Bild wählen",
  "changeImage": "Bild ändern",
  "removeBanner": "Entfernen",
  "bannerHint": "Gestalten Sie für 600 px Breite — das entspricht dem Standard-Bannerplatz. Die Höhe ist flexibel; etwa 100 px ist üblich. Eine Kampagne ohne Banner zeigt nichts an, egal was der Zeitplan sagt.",
  "link": "Link",
  "linkDescription": "Wohin ein Klick führt. Wird beim Senden in eine Tracking-Umleitung gepackt.",
  "linkPlaceholder": "https://beispiel.com/angebot",
  "linksTo": "Verlinkt auf {{url}}",
  "altText": "Alt-Text",
  "altTextDescription": "Wird von Screenreadern vorgelesen und von Clients angezeigt, die Bilder blockieren — die meisten standardmäßig.",
  "timezoneHint": "Zeiten sind in Ihrer lokalen Zeitzone. Lassen Sie das Ende leer für ein Banner, das läuft, bis jemand es stoppt.",
  "createDraft": "Entwurf erstellen",
  "save": "Speichern",
  "saveCampaign": "Kampagne speichern",
  "createTitle": "Neue Kampagne",
  "editTitle": "Kampagne bearbeiten",
  "saved": "Kampagne gespeichert.",
  "createdDraft": "Als Entwurf erstellt. Planen oder starten Sie sie, wenn Sie bereit sind.",
  "saveError": "Das konnte nicht gespeichert werden.",
  "deleted": "{{name}} gelöscht.",
  "deleteError": "Kampagne konnte nicht gelöscht werden.",
  "statusUpdated": "Kampagne {{verb}}.",
  "statusError": "Das konnte nicht geändert werden.",
  "actionsAria": "Aktionen für {{name}}",
  "windowNoDates": "Keine Daten gesetzt — läuft nur, wenn manuell gestartet.",
  "windowFromOpen": "Ab {{starts}}, bis jemand sie beendet.",
  "windowUntil": "Bis {{ends}}.",
  "windowRange": "{{starts}} bis {{ends}}."
}
